var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"large":"","width":_vm.width}},[(_vm.icon)?[_c('v-img',{staticClass:"shrink ml-3",attrs:{"alt":"TCDC_LOGO","contain":"","src":require("@/assets/google_icon.png"),"transition":"scale-transition","width":"30px"}})]:_vm._e(),_vm._v("\n  "+_vm._s(_vm.label)+"\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }